<template>
  <div id="main-header">
    <div class="ui menu">
      <router-link to="/"
                   id="midas-logo"
                   class="item">
        <div class="logo-globe"></div>
        <div class="logo-text"></div>
      </router-link>

      <div id="page-title"
           class="item">
        <h1 v-if="$root.currentView">
          <router-link :to="$root.currentView.route"
                       class="gts-btn">
            <i :class="$root.currentView.icon + ' icon'"></i>
            <span v-html="$root.currentView.label"></span>
          </router-link>
        </h1>
      </div>

      <div class="right menu">

        <div class="icon gts-btn display-none item"
             @click="showAdvMsgs"
             id="global-notifications-icon">
          <i class="large bell outline icon"
             title="View Notifications"></i>
          <!-- <span class="ui mini red circular label">2</span> -->
          <i class="orange notification circle icon"
             v-if="!ackNotification"></i>
        </div>

        <div class="ui dropdown centered item"
             id="signed-in-user">
          <div class="text">
            {{ currentUserFullName }}
            <div id="user-role"
                 v-if="currentUserHighestRole">{{ currentUserHighestRole }}</div>
          </div>
          <i class="dropdown icon"></i>
          <div class="menu">
            <router-link class="item"
                         to="/">
              <i class="home icon"></i>Home
            </router-link>

            <div v-if="onboardingTask"
                 class="divider"></div>

            <router-link v-if="onboardingTask"
                         class="item"
                         :id="onboardingTask?.name"
                         :to="onboardingTask?.route">
              <i :class="onboardingTask?.icon + ' green icon'"></i>
              <span class="ui green sub header">{{ onboardingTask?.label }}</span>
              <!-- Account Sign Up -->
            </router-link>

            <div class="divider"></div>

            <router-link v-for="t in activeTasks"
                         :key="t.label"
                         class="item"
                         :class="{ 'disabled': t.disabled }"
                         :id="t.name"
                         :to="t.route">
              <i :class="t.icon + ' icon'"></i>
              {{ t.label }}
            </router-link>

            <div class="divider"
                 v-if="$root.tasks.Management"></div>

            <router-link v-for="t in managementTasks"
                         :key="t.label"
                         class="item"
                         :id="t.name"
                         :to="t.route">
              <i :class="t.icon + ' icon'"></i>
              {{ t.label }}
            </router-link>

            <div class="divider"></div>

            <a id="contact-us--menu"
               class="item"
               target="_blank"
               :href="serviceDeskURL">
              <i class="blue comment dots icon"></i>
              <span class="ui blue sub header">Contact Us</span>
            </a>

            <a id="faq--menu"
               class="item"
               target="_blank"
               href="//connectsupport.globetax.com">
              <i class="blue question circle outline icon"></i>
              <span class="ui blue sub header">FAQ</span>
            </a>

            <!-- <div class="divider"></div>

            <div id="settings--menu"
                 class="item">
              <i class="left dropdown icon"></i>
              <div class="text">Advanced Settings</div>
              <div class="left menu">
                <a class="item"><i class="user friends icon"></i> Configure &apos;View As User&apos;</a>
                <div class="divider"></div>
                <a class="disabled item"><i class="edit icon"></i> Edit Profile</a>
                <a class="disabled item"><i class="globe icon"></i> Choose Language</a>
              </div>
            </div> -->

            <div class="divider"
                 v-if="signOutTask"></div>

            <a class="item"
               v-if="signOutTask"
               @click="$root.signOutCurrentUser"
               :id="signOutTask.name">
              <i :class="signOutTask.icon + ' icon'"></i>
              {{ signOutTask.label }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ackNotification: false,
    }
  },
  computed: {
    currentUserFullName() {
      let _user = this.$root.currentUser
      return _user ? _user.firstName + ' ' + _user.lastName : 'Test User'
    },
    currentUserHighestRole() {
      // TODO
      // return null
      return this.$root.currentUser.email
    },
    activeTasks() {
      return this.$root.tasks.Features.filter(
        (t) => !t.isHidden || t.isHidden === 'false'
      )
    },
    managementTasks() {
      return this.$root.tasks.Management?.filter((t) => t.name !== 'myAccounts')
    },
    onboardingTask() {
      return (
        this.$root.tasks.Management?.find((t) => t.name === 'myAccounts') || null
      )
    },
    signOutTask() {
      return this.$root.tasks.SignOut ? this.$root.tasks.SignOut[0] : null
    },
    serviceDeskURL() {
      return SERVICE_DESK_URL
    },
  },
  methods: {
    showAdvMsgs($event) {
      let vm = this

      $($event.target).toast({
        header: 'We have received your transaction data',
        message: 'GlobeTax has received your transaction data',
        className: {
          toast: 'ui info tiny message',
        },
        closeIcon: true,
        displayTime: 0,
        actions: [
          {
            text: 'Show me around',
            class: 'tiny green',
            click: function () {
              vm.$router.push('/reports/reclaim-dashboard/summary')
            },
          },
        ],
        onVisible() {
          vm.ackNotification = true
        },
      })
    },
  },
  mounted() {
    $('#signed-in-user').dropdown({
      on: 'hover',
      action: 'select',
    })
  },
}
</script>

<style lang="stylus">
@import '../assets/styles/colors';
@import '../assets/styles/mixins';

#main-header {
  position: relative;

  & > .ui.menu {
    background: $gts-lightgray;
    vendor(border-radius, 0);
  }
}

#signed-in-user,
#midas-logo {
  background-color: transparentify(#fff, 5%) !important;
  vendor(border-radius, 0);

  &:hover {
    background-color: transparentify(#fff, 95%) !important;
  }
}

#user-role {
  margin-top: 0.25rem;
  text-align: center;
  text-transform: uppercase;
  font-size: 0.7rem;
  font-weight: 300;
  color: $lightgray-color;
}

#midas-logo {
  .logo-globe {
    height: 38px;
    width: 38px;
    margin-right: 1rem;
    background-image: url('../assets/images/MIDAS/midas-globe-gold-lo.png');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;
  }

  .logo-text {
    height: 34px;
    width: 74px;
    margin-top: 2px;
    background-image: url('../assets/images/MIDAS/midasconnect_Lo.png');
    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;
  }
}

#page-title {
  padding-left: 1.5rem;

  &:before {
    width: 0 !important;
  }

  h1 {
    text-transform: uppercase;
    color: $gts-text-color !important;

    & > a {
      color: inherit;

      & > i {
        margin-right: 0.75rem;
        vertical-align: baseline;
      }
    }
  }

  h1,
  i {
    text-shadow();
  }
}

#signed-in-user {
  font-weight: bold;

  .menu > .divider {
    margin: 0;
  }

  .menu {
    z-index: 9999;
  }
}

/* custom to match other icons width */
.ui.dropdown > .menu > .item > i.file.image.icon {
  width: 1.18em;
}

#global-notifications-icon {
  padding: 1rem 2rem;

  i {
    font-size: 1.8rem;
  }

  &:hover {
    background: #fff;
  }

  .circular.label {
    display: inline-block;
    position: absolute;
    top: 0.5rem;
    right: 1rem;
  }

  .notification.circle {
    display: inline-block;
    position: absolute;
    right: 1rem;
    font-size: 0.5rem;
  }
}
</style>